export type UserData = {
  id: string;
  name: string;
  email: string;
  phone: string;
  picture: string | null;
  trackingId: string;
  profileUrl: string;
  cartItems: number | null;
  context: 'ecommerce' | 'assisted-sale' | 'app' | 'app-store';
  isLegalUser: boolean;
  isEmployee: boolean;
  zipCode: string;
};

export class User {
  constructor(private readonly data: UserData) {}

  get email() {
    return this.data.email;
  }

  get phone() {
    return this.data.phone;
  }

  get name() {
    return this.data.name;
  }

  get id() {
    return this.data.id;
  }

  get profileUrl() {
    return this.data.profileUrl;
  }

  get cartItems() {
    return this.data.cartItems;
  }

  get picture() {
    return this.data.picture;
  }

  get isLegalUser() {
    return this.data.isLegalUser;
  }

  get trackingId() {
    return this.data.trackingId;
  }

  get isEmployee() {
    return this.data.isEmployee;
  }

  get isAssistedSale() {
    return this.data.context === 'assisted-sale';
  }

  get isLoggedIn() {
    return Boolean(this.data.id);
  }

  get zipCode() {
    return this.data.zipCode;
  }
}
